export { track as default } from '../adapters/segment/segment'

// TODO: we should move all non-segment-specific logic to this file
